import { render, staticRenderFns } from "./CustomerPage.vue?vue&type=template&id=a2b6e0b0"
import script from "./CustomerPage.vue?vue&type=script&lang=ts"
export * from "./CustomerPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports